{
  "cost_to_date_human": "$24.50",
  "days_remaining": "8",
  "display_name": "Andre",
  "month_human": "May 2026",
  "percent_used": "82",
  "settings_url": "https://dev.hearthfire.ai/settings/ai",
  "tokens_cap_human": "5,000,000",
  "tokens_used_human": "4,100,000"
}
